export const route = {
    params: {
        id: 'id',
    },
    patterns: {
        createNewLearningOpportunity: '/learning-opportunities-v2/new',
        learningOpportunities: '/learning-opportunities-v2',
        learningOpportunityDetails: '/learning-opportunities-v2/:id',
        learningOpportunityEdit: '/learning-opportunities-v2/:id/edit',
    },
    searchParams: {
        filtration: {
            skillFilter: 'skillFilter',
            workspaceFilter: 'workspaceFilter',
        },
        navigation: {
            courses: 'courses',
        },
        searchTerm: 'search',
        state: 'state',
        tab: 'tab',
    },
} as const;

export const learningOpportunityEditPageUrl = (learningOpportunityId: string): string =>
    route.patterns.learningOpportunityEdit.replace(':id', learningOpportunityId);
